import {Bar} from 'react-chartjs-2';
import NoItems from "./NoItems";


const ReservationStats = ({reservationStats}) => {

    const options = {
        responsive: true,
    };
    const labels = ['Január', 'Február', 'Március', 'Április', 'Május', 'Június', 'Július', 'Augusztus', 'Szeptember', 'Október', 'November', 'December'];

    const data2 = {
        labels,
        datasets: [
            {
                label: 'Foglalások',
                data: reservationStats,
                backgroundColor: 'rgba(255, 99, 132, 0.5)',
            },
        ],
    };
    const sum = reservationStats?.reduce((acc, value) => acc + value, 0)
    if (sum === 0) return <NoItems
        title='Még nincsenek foglalásaid'
        description='Itt fognak megjelenni a foglalási statisztikáid a havi bontásában.'
    />
    return <Bar options={options} data={data2}/>
}

export default ReservationStats;